enum MedicationsSortOptions {
  InjectableDueDate = 'InjectableDueDate',
  StartDate = 'StartDate',
  EndDate = 'EndDate',
}

export default MedicationsSortOptions;
